import type { Cities, City, CityApi, CityFilters } from '../../models';

export const normalizeCity = (city: CityApi): City => ({
  id: city.cityName,
  label: city.cityName,
});

export const normalizeCities = (cities: CityApi[]): Cities => {
  const list = cities.map(normalizeCity).sort((a, b) => a.label.localeCompare(b.label));

  return {
    list,
    map: list.reduce(
      (acc, city) => {
        acc[String(city.id)] = city;
        return acc;
      },
      {} as Cities['map'],
    ),
  };
};

export const filterCities = (cities: Cities, filters: Partial<CityFilters> = {}): Cities => {
  let { list } = cities;

  const searchQuery = filters.search?.cityName?.trim()?.toLowerCase();
  if (searchQuery) {
    list = list.filter((city) => {
      const name = city.label.toLowerCase();
      const code = String(city.id).toLowerCase();
      return name.includes(searchQuery) || code.includes(searchQuery);
    });
  }

  return {
    list,
    map: list.reduce(
      (acc, city) => {
        acc[String(city.id)] = city;
        return acc;
      },
      {} as Cities['map'],
    ),
  };
};
